exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!./../node_modules/css-loader/index.js!./buttons.css"), "");

// module
exports.push([module.id, ".easy-button{width:300px;height:300px}#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50;margin-top:60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-42826872!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 4
// module chunks = 0